import { createAction, handleActions } from "redux-actions";

const SET = 'keypad.SET';
const CLEAR = 'keypad.CLEAR';

const defaultState = {
  orientation : '',
  tabIndex : '0',
  moreKeyName : '',
  moreKeyIndex : '',
  arrowKeyTooltipStatus : 1
};

const setKeypadAction = createAction( SET, payload => payload );
const clearKeypadAction = createAction( CLEAR );

const keypad = handleActions( {
  [ SET ] : ( state, action ) => ( { ...state, ...action.payload } ),
  [ CLEAR ] : () => defaultState
}, defaultState );

export default keypad;
export { setKeypadAction, clearKeypadAction };
